import styled from 'styled-components';

export const DatosLabolares = styled.div`
  .label.tipo-cargo div {
    font-size: 0.8rem;
    outline: #646569;
  }

  i.coopeuch-icon.icon-old._1sTuD._1ZA_Y._2HYPo {
    display: none;
  }

  .mensaje-informacion ._3NSXd {
    font-size: 0.8rem !important;
    margin-top: 2px;
  }

  .tooltip-div ._2kFow {
    position: absolute;
    left: 38%;
    top: -2px;
  }
  
  ._2kFow {
    margin-bottom: -1px;
  }

  input:focus,
  ._3kii5 textarea:focus {
    border-color: #646569;
  }

  .jzgaAI ._3kii5 input {
    line-height: 28px;
  }

  ._3kii5 input {
    padding: 9.5px 0.75rem !important;
    font-size: .8rem !important;
  }

  div#cargo-selector label {
    // margin-bottom: 5px;
    color: #383838;
  }

  div#contrato-selector input,
  div#tiempo-trabajando-selector input {
    border-radius: 28px;
    font-size: 0.8rem;
  }

  ._3k3jO._tQrqh {
    color: #9c9a9f;
  }

  .hace-cuento-trabajas-div ._Do9PN {
    height: 146px;
  }

  form.formulario-datos-laborales label {
    font-size: 0.8rem;
  }

  .label div span {
    // color: #383838;
    font-size: 0.7rem;
  }

  .label.tooltip-div button {
    border: none;
    outline: none;
    background: transparent;
  }

  .label-renta > .tooltip {
    display: flex;
  }

  .label-renta > .tooltip > p {
    color: #383838;
    font-weight: bold;
    font-size: 0.8rem;
    margin-right: 0.5rem;
    line-height: 22px;
    position: relative;
  }

  @media (min-width: 800px) {
  }

  @media (max-width: 768px) {
  }

  @media (max-width: 425px) {
    ._2kFow ._3hy_8[data-placement='top'] ._T5dKc {
      left: 45%;
    }

    .mensaje-informacion {
      margin-top: 19px;
    }

    ._3sTov ._3g_Jc ._10WAf ._3NSXd {
      font-size: 0.8rem !important;
      width: 66%;
    }
    ._3g_Jc p {
      font-size: 0.7rem;
      line-height: 20px;
      width: 85%;
    }
    .Autocomplete-input-wrapper input {
      font-size: 0.7rem;
    }
    ._1oqQj ._2rl6s {
      width: 29px;
      margin-right: 6px;
    }
  }

  @media (max-width: 375px) {
    ._1oqQj ._2rl6s {
      width: 29px;
      margin-right: 6px;
    }

    ._2kFow ._3hy_8[data-placement='top'] ._T5dKc {
      left: 45%;
    }
    .mensaje-informacion {
      margin-top: 19px;
    }
    ._3sTov ._3g_Jc ._10WAf ._3NSXd {
      font-weight: 100;
      font-size: 0.7rem;
      width: 66%;
    }
    ._3g_Jc p {
      font-size: 0.7rem;
      line-height: 20px;
      width: 85%;
    }
    .Autocomplete-input-wrapper input {
      font-size: 0.7rem;
    }
    form.formulario-datos-laborales label {
      font-size: 0.7rem;
    }
    ._1oqQj ._2rl6s + label {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 320px) {
    ._1oqQj ._2rl6s {
      width: 29px;
      margin-right: 6px;
    }

    ._2kFow ._3hy_8[data-placement='top'] ._T5dKc {
      left: 55%;
    }

    .mensaje-informacion {
      margin-top: 19px;
    }
    ._3sTov ._3g_Jc ._10WAf ._3NSXd {
      font-size: 0.7rem !important;
    }
    ._3g_Jc p {
      font-size: 0.7rem;
      line-height: 20px;
      width: 85%;
    }
    .Autocomplete-input-wrapper input {
      font-size: 0.7rem;
    }
    .formulario-datos-laborales {
      padding-bottom: 15px;
    }
    ._3sTov .label ._1F3qg,
    .gufKeR ._3sTov .label ._3IoKh span {
      font-size: 0.6rem;
    }
    form.formulario-datos-laborales label {
      font-size: 0.7rem;
    }
    ._1oqQj ._2rl6s + label {
      font-size: 0.8rem;
    }
  }
`;

export default DatosLabolares;
